import ConsentProvider from "./ConsentProvider";
// Cookiebot should use auto-mode (data-blockingmode="auto"), but
// we support manually sent event to be filtered anyway
class CookieBotProvider extends ConsentProvider {
    constructor(onChangeCallback) {
        super();
        /*
        // We need to listen for the event, so we can send it to the analytics
        // providers
        window.addEventListener("CookiebotOnAccept", () => {
          // FIXME: Should we support more than statistics?
          const consent = window.CookieConsent?.consent["statistics"] || false;
          console.log(
            "[Consent/Cookiebot] eventlistener: Setting tracking allowed",
            consent,
          );
          onChangeCallback(consent);
        });
         */
    }
    // If the provider is in charge of sending consent data to GTM and tracking
    // services. If so, we allow all tracking and let GTM stop it
    handleConsentPush() {
        return true;
    }
    getAllowTracking() {
        // We have to assume that Cookiebot push the correct google tag manager
        // consent to the dataLayer
        return true;
        /*
        const trackingAllowed =
          window.CookieConsent?.consent?["statistics"] || false;
        console.log(
          "[Consent/Cookiebot] Return tracking allowed",
          trackingAllowed, window.CookieConsent
        );
        return trackingAllowed;
         */
    }
}
export default CookieBotProvider;
